module.exports = __webpack_public_path__ + "static/media/help-center.c7943515.jpg";